import { h } from 'preact';
import {useContext, useEffect, useState} from 'preact/hooks';
import { BrowseContext } from '../store/BrowseContextProvider';
import { IntlProvider, Text } from 'preact-i18n';
import { TranslationUtil } from '../utils/TranslationUtil';
import { ExtensionUtil } from '../utils/ExtensionUtil';
import { RtlUtil } from '../utils/RtlUtil';
import { browseAdClick } from '../utils/SiteAnalytics';

import './_installad.scss';

// Components for install ad, download button, and supported browser text
export const InstallAd = (props) => {
  const [definition, setDefinition] = useState({});
  let lang = props.lang ? props.lang : TranslationUtil.GetSupportedLanguage();
  const ctx = useContext(BrowseContext);
  const storeLink = ExtensionUtil.GetStoreLink(ctx.browserName, lang, ctx.adSource, ctx.adMedium, ctx.adCampaign, "WebSafety");
  const linkTarget = ExtensionUtil.GetStoreLinkOpenTarget(ctx.browserName);
  const isRightToLeft = RtlUtil.GetSetRtl(lang);

  //ad in mobile, small screen

  useEffect(() => {
    TranslationUtil.GetDefinition(lang, "landing").then(resp => {
      setDefinition(resp);
    })
  }, [lang])

  const downloadClick = () => {
    browseAdClick(ctx.adSource, ctx.adMedium, ctx.adCampaign);
    window.open(storeLink, linkTarget);
  }
  if(ctx.showAd) {
    return (
      <IntlProvider definition={definition}>
          <div className="ae-subtitle-normal" style={{display: "flex", flexFlow: "row", padding: "5px", paddingInlineEnd: "25px", alignItems: "center", justifyContent: "center"}}>
            <div><Text id="landing.webSafetyAdTitle">Keep your browsing safe and clean.</Text></div>
            <div style={{marginInlineStart: "5px"}}>
              <a href="javascript:void(0)" onClick={downloadClick} style={{color: "var(--lightBlue)"}}>
                <Text id="landing.adInstallText" fields={{browser: ctx.browserStoreText}}>
                  Click here to install from {ctx.browserStoreText}
                </Text>
              </a>
            </div>
            <div style={{marginInlineStart: "5px"}}>
              <img src={ctx.browserStoreImage} className='browser-logo' style={{width: "20px", height: "20px"}}/>
            </div>
            <div className="pointer-cursor" style={isRightToLeft ? {position: "absolute", left: "0px"} : {position: "absolute", right: "0px"}}>
              <span className="closeIcon" onClick={ctx.hideAd}><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="var(--bgLightGray)"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"></path></svg></span>
            </div>
          </div>
      </IntlProvider>
    )
  } else {
    return ("");
  }
}
